module.exports = __webpack_public_path__ + "images/emoji/scream.f7ce0a32dcb4084fc11e.png";